<template>
    <div class="modal-container has-text-centered" style="overflow: auto">
         <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
        <div class="has-text-dark  bottom20">
           <div class="top40"> <div class="is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3 has-text-white"> MULTI SELECT ACTIONS</span></div></div>
            <br>
           <div class="has-text-white">TAG:</div>
           <br>

             <div  class="" style="max-width: 398px; margin: 0 auto 7px auto">
                <div class="tagsView inMulti roundedCorners2">
                    <div class="top5 has-text-left left3 is-size-65 has-text-white">&nbsp;tags:</div>
                    <tags-input element-id="tags" class="top-10 has-text-left" id="taginput"
                            v-model="processedTags"
                            :existing-tags="$root.app.tagUniverse"
                            :typeahead="true"
                            :typeahead-hide-discard="false"
                            :typeahead-show-on-focus="false"
                            >
                    </tags-input>
                </div>
            </div>

           
   
           <div class="has-text-white">ASSIGN TO ANOTHER BUNDLE</div>

           <div v-show="!fromInbox" class="has-text-white is-size-7">You can also choose to keep a copy in the current bundle.</div>
           <div  class="has-text-white is-size-7 bottom10">Unchecking all bundles will delete the miimus.</div>
           

          


        <!-- TREE -->
        
        <div v-show="!$parent.newModalHideTree" class="has-text-left">
           
             <div class="roundedCorners2 marginAutod">
                <div class="has-background-dark">&nbsp;<span class="is-inline-block top2"><b>&nbsp;save into:</b>&nbsp;</span>
                <input @change="bundleFilter" type="text" class="is-pulled-right azTextInput right1 " style="width: 100px" v-model="bundleSearchTerm"/>
                <i class="is-pulled-right top3 right5 has-text-light is-size-7">filter:</i></div>
                <div class="treeView has-background-dark" style="height: 320px;">
                    <tree-4-bundles ref="node" v-for="(item, index) in filteredTreeNoInbox" 
                            :key="index" 
                            :listName="item.listName" 
                            :children="item.children" 
                            :depth="0" 
                            :id="item.id" 
                            :aliasTgtId="item.aliasTgtId" 
                            :hideMe="item.hideMe"
                            :isCollab="item.isCollab"
                            :caller="'multi'"
                            :curr = "currId"
                            >
                    </tree-4-bundles>
                    <br>
                </div>
            </div>
        </div>
        <br>
       <!--  <input v-show="!forceRemove" type="checkbox" @click="toggleRemove"/><span v-show="!forceRemove" class="has-text-white">&nbsp;&nbsp;Also keep in current bundle</span> -->

       

        </div>
        


        <button v-show="!sure"  id="saveButt" class="button is-small  is-coolGreen wideButton top10" @click="showSure">SAVE</button><br>

        <div v-show="hasForeign && sure" class="pad5 top-40">Some of the selected miimus were contributed by other users. If you are moving them to your own bundles, copies will be made instead. If removing miimus, only your miimus will be removed.</div>
        <div v-show="!hasForeign && sure" class="pad5 top-40">This will remove the selected miimus from this bundle.</div>
        <div class="top10"><span v-show="sure" class="has-text-white is-size-7"><b>Proceed? </b>&nbsp;<button class="button is-coolGreen tiny" @click="save">YES</button>&nbsp;<button class="button tiny" @click="sure = false">NO</button></span></div>
        
        
    <!--      <div v-show="createOrEdit == 'edit'" class="top10 has-text-centered">
            <div v-show="!sure" class="cancelButton has-text-grey" @click="sure =  true">Delete</div>
            <span v-show="sure" class="has-text-white is-size-7"><b>Sure?</b>&nbsp;<button class="button is-coolGreen tiny" @click="deleteBundle">YES</button> <button class="button tiny" @click="sure = false">NO</button></span>
        </div> -->

           <br> 
            <!--  <div class="has-text-white">DELETE:</div>
           <button v-show="!sure" class="button is-small top10 is-coolGreen" @click="showShure">Delete miimus from current Bundle</button> 
           <div v-show="hasForeign && sure" class="pad5">Some of the selected miimus were contributed by other users. Only your miimus will be deleted.</div>
           <div class="top10"><span v-show="sure" class="has-text-white is-size-7"><b>{{hasForeign ? 'Proceed?' : 'sure?'}} </b>&nbsp;<button class="button is-coolGreen tiny" @click="delMiimus">YES</button>&nbsp;<button class="button tiny" @click="sure = false">NO</button></span></div> -->
        <div>&nbsp;</div>

       <!--  <div class="cancelButton  top10" @click="cancel">Cancel</div> -->
    </div>
</template>

<script>

import { AZEventBus } from './AZEventBus'
import Tree4Bundles from '../components/Tree4Bundles'
import VoerroTagsInput from '@voerro/vue-tagsinput'

export default{
    components: {Tree4Bundles, "tags-input": VoerroTagsInput},
    props: {
        items: {
            type: Array,
            default: function(){ return []}
        },
        callBack: {
            type: Function
        },
        bundleName: {
            type: String,
            default: ''
        },
        createOrEdit: {
            type: String, 
            default: 'create'
        },
        sub: {
            type: Boolean,
            default: true
        },
        bundleId: {
            type: Number,
            default: -1
        },
        collabId: {
            type: Number,
            default: null
        },
        bParent: {
            type: Number,
            default: null
        },
        aliasTgtId: {
            type: Number,
            default: null
        },
        selectedId: {
            type: Number,
            default: 0
        },
        selectedAliasId: {
            type: Number,
            default: 0
        },
        me: {
            type: Number,
            default: null
        },
        forceRemove: {
            type: Boolean,
            default: false
        },
        fromInbox: {
            type: Number,
            default: null
        }

    },
    data: function(){
       return {
            sure: false,
            groups: [],
            inView: 0,
            newGroup: true,
            connects: [],
            err: '',
            isCollab: false,
            tempCollabId: null,
            showPlaceholder: false,
            bundleSearchTerm: '',
            selectedCollabId: null,
            doChangeParent: false,
            newTagsArr: [],
            selectedTags: [],
            hasForeign: false,
            incomingCollabId: null,
            showForeignTarget: false,
            remove: false,
            currId: null,
            bypassWarning: false,
            currAliasId: null

       }
    },
    mounted: function(){
      

        let self = this

        if(this.forceRemove) this.remove = true

      
        AZEventBus.$on('onTreeNodeClicked', this.onTreeNodeClickedHandler);

        function autoSel(arr, id){
            if(!arr)
                return

            arr.forEach(e => {
                if(e.id == self.selectedId){
                    e.isSelected = true
                    e.$refs.cb.checked = true

                    let br = []
                    let c = e
                    br.push(e.id)
                    for(var x = e.depth; x > 1; x--){
                        br.push(c.$parent.id)
                        c = c.$parent
                    }

                    AZEventBus.$emit('filteredBundles', br)

                } else {
                    e.isSelected = false
                    if(e.$refs.cb)
                        e.$refs.cb.checked = false
                }

                if(e.id == self.me){
                    e.hideMe = true
                }

                if(e.children.length){
                    autoSel(e.$refs.node)
                }
            })
        }

        autoSel(self.$refs.node)
        this.incomingCollabId = this.collabId
        this.currId = this.selectedId
        this.currAliasId = this.selectedAliasId
        
    

        this.selectedId = null
        this.selectedAliasId = null

       /*  if(self.selectedId == 0){
            self.$refs.node[0].isSelected = true;
            self.$refs.node[0].$refs.cb.checked = true;
        }  */
       
    },

    beforeDestroy: function(){
        AZEventBus.$off('onTreeNodeClicked', this.onTreeNodeClickedHandler)
    },

    methods:{

        onTreeNodeClickedHandler: function(msg){
            var self = this;  //was pasted from other scope that was deeper than "this"

            var hasForeign = false
            this.items.forEach(e => {
                if(!e.myCard)
                    self.hasForeign = true
            })

            self.doChangeParent = true


           

            //Remove all selections
            function clear(arr){
               
                if(!arr)
                     return

                self.selectedId = null,
                self.selectedAliasId = null
                arr.forEach(e => {
                    if(!e.hideMe){

                        if(e.id == self.currId){
                            return
                        }

                        if(e.id == msg.wrapperId){
                            e.isSelected = !e.isSelected
                            if(!e.isSelected){
                                self.selectedId = null
                                self.selectedAliasId = null
                            }
 
                        } else {
                            e.isSelected = false
                            if(e.$refs.cb)
                                e.$refs.cb.checked = false
                        }

                        if(e.children.length){
                            clear(e.$refs.node)
                        }
                    }
                    
                })
            }


            if(msg.wrapperId != self.currId){
                clear(self.$refs.node)
               
            } else {
                self.remove = !self.remove
            }


            self.selectedCollabId = msg.collabId

             if(self.selectedCollabId != self.incomingCollabId){
                 self.showForeignTarget = true
             }
        },

        save: function(){
            var self = this;

            function getSelectedNodes() {
                const selectedNodes = [];

                // Recursive function to traverse components
                function traverseNodes(nodes) {
                    nodes.forEach((node) => {
                            if (node.isSelected) {
                            selectedNodes.push(node);
                            }

                            // Recursively check child components
                            if (node.$children.length) {
                                traverseNodes(node.$children);
                            }
                        });
                }

                // Start recursion from root nodes
                if (self.$refs.node) {
                    traverseNodes(self.$refs.node);
                }

                return selectedNodes;
            }

            var selectedNodes = getSelectedNodes()


            self.selectedId = null
            self.selectedAliasId = null
            
            selectedNodes.forEach(e => {
                
                if(e.isSelected && e.id != self.currId){
                    self.selectedId = e.id
                    self.selectedAliasId = e.aliasTgtId
                }
            })

           
            function w(d){

                

                if(d == 'miimu limit exceeded'){
                        if(!self.$root.app.inApp)
                            self.$root.app.doShowModal('ModalUpg', {limit: 'm'})
                        else
                            self.$root.app.doShowModal('ModalOK', {message: `Congratulations! You've created a ton of miimus! To create more, please visit your account settings from any web browser.`})

                        return
                }

                

               d.tags.forEach(e => {
                   var obj = {
                       entryId: e.entryId,
                       id_TAGS: e.id_TAGS,
                       tag: e.tag
                   }

                   var c = self.$root.app.cards.find(f => {
                       return f.id == e.id_CARDS
                   })

                   c.tags.push(obj)
               })

               var theBundle = null

               

               d.cards.forEach(e => {
                   //find it in CARDS and add parent
                   var c  = self.$root.app.cards.find(n => {
                       return n.id == e.id_CARDS
                   })
                  

                   if(c){
                       c.parents.push({entryId: e.entryId, id: e.id_BUNDLES, p: e.p})
                   } else {
                       
                       var ttCard = self.$root.app.cards.find(r => {
                           return r.id == e.origId
                       })
                       var tempoCard = JSON.parse(JSON.stringify(ttCard))
                       tempoCard.parents = [{entryId: e.entryId, id: e.id_BUNDLES, p: e.p}]
                       tempoCard.id = e.id_CARDS
                       tempoCard.myCard = true
                       tempoCard.id_cog = self.$root.app.userAttrs.sub
                       tempoCard.origId = e.origId
                       tempoCard.imported = true
                       tempoCard.modDate = new Date().toISOString()
                       self.$root.app.cards.push(tempoCard)

                      
                   }

                   var ci = self.$root.app.cards.findIndex(n => {
                       return n.id == e.id_CARDS
                   })

                 
                   

                   var b = self.$root.app.bundles.find(n => {
                       var temp = n.aliasTgtId || n.id
                       return temp == e.id_BUNDLES
                   })

                   if(b){
                       theBundle = b
                       b.items.push({cardsIndex: ci, entryId: e.entryId, id: e.id_CARDS, id_cog: self.$root.app.userAttrs.sub, p: e.p})
                   }
               })

               if(d.cards.length && theBundle){
                   theBundle.items.sort(function(a,b){ return a.p - b.p})
               }

              

               //remove

               if(self.remove){
                   d.myCards.forEach(e => {
                       //remove parent from card
                       var cc = self.$root.app.cards.find(n => {
                           return n.id == e
                       })

                       var par = cc.parents.findIndex(m => {
                           return m.id == self.currId
                       })

                       cc.parents.splice(par, 1)

                       //remove item from bundle

                       var bb = self.$root.app.bundles.find(l => {
                          return l.id == parseInt(self.currId)
                       })

                       var ipar = bb.items.findIndex(l => {
                           return l.id == e
                       })

                       bb.items.splice(ipar, 1)
                   })
               }


               az.addRemSpinner(false, 'id', 'saveButt')
               self.callBack()
               self.$emit('close');
            }

            function n(){
                az.addRemSpinner(false, 'id', 'saveButt')
            }


            function checkObjProps(object, key) {
                return object[Object.keys(object)
                    .find(k => k.toLowerCase() === key.toLowerCase())
                ];
            }


            var ids = []

            this.items.forEach(e => {
                ids.push(e.id)
            })

            //TAGS: make list of ids
         

            //Make list of tags to add 
            var addTags = []
            for (var x = 0; x < this.newTagsArr.length; x++) {
                var e = this.newTagsArr[x]
                let i = this.selectedTags.findIndex(a => {
                    return a.tag == e
                })

               
               
                if(i == -1){
                  
                    addTags.push(e)

                    if(checkObjProps(self.$root.app.tagUniverse, e) != undefined){
                        self.$root.app.tagUniverse[e] = e;
                    }
                    
                }
            }      
            
            az.addRemSpinner(true, 'id', 'saveButt')

            if(this.fromInbox){
                var temp = this.selectedAliasId || this.selectedId 
                if(temp == this.fromInbox){
                    this.remove = false
                }
            }


            var checkLimits = this.$root.app.checkLimits
            this.$root.app.apiClient.post('subs/data/multi', {checkLimits: checkLimits, targetId: this.selectedAliasId || this.selectedId, currId: this.currAliasId || this.currId, cardIds: ids, addTags: addTags, remove: this.remove, collabId: this.collabId}, w, n)
            
        },

        toggleRemove: function(){
            this.remove = !this.remove;

            if(!this.remove){
                AZEventBus.$emit('makeDim', {id: this.currId, turnOn: true})
            } else {
                AZEventBus.$emit('makeDim', {id: this.currId, turnOn: false})
            }
        },


        cancel: function(){
            this.$emit('close');
        },

        bundleFilter: function(){

            if(this.bundleSearchTerm == ''){
                AZEventBus.$emit('collapseTrees', null)
                AZEventBus.$emit('treesCheckIfSelected', null)
                return
            }

            var filteredBundles = []
            
            var filtered = this.$root.app.bundles.filter(e => {
                /* return e.listName.toLowerCase() == this.bundleSearchTerm.toLowerCase() */

                let i = e.listName.toLowerCase().indexOf(this.bundleSearchTerm.toLowerCase())

                if(i == 0) 
                    return true
                else
                    return false
            })

            filtered.forEach(e => {
                filteredBundles.push(e.id)
            })

            AZEventBus.$emit('collapseTrees', null)
            AZEventBus.$emit('filteredBundles', filteredBundles)

        },


        showSure: function(){

            var self = this;
            
               
            //check for foreign miimus
            var f = false
            self.items.forEach(e => {
                if(!e.myCard){
                    f = true
                }
            })

            if(f){
                this.hasForeign = true
            } else {
                this.hasForeign = false
            }
                

            if(this.hasForeign){
                this.sure = true
            } else {
                this.save()
            }
        },

        noSelected: function(){

        },


        
        

    },

    computed: {
        filteredTreeNoInbox: function(){

            var arr = this.$root.app.treeNoInbox.slice(0)
            //var arr2 = [{listName: 'Root', id: 0, aliasTgtId: 0, children: arr}]
            return arr

        },

        processedTags: {
            get: function(){
                var arr = []
                if(this.selectedTags){
                    this.selectedTags.forEach(e => {
                        arr.push(e.tag)
                    })
                }

                return arr
            },

            set: function(newVal){
                this.newTagsArr = newVal
            }

            
        },
    }
     
}

</script>

<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }

    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }

</style>